import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsNotNullOrUndefinedPipe } from '../pipes/is-not-null-or-undefined.pipe';



@NgModule({
  declarations: [
    IsNotNullOrUndefinedPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    IsNotNullOrUndefinedPipe
  ]
})
export class SharedModule { }
